export const statisticsDistanceInKmOptions = [50, 100];
